<template>
  <ConfirmModal
      color="primary"
      icon="mdi-skip-next"
      :maxWidth="500"
      itemKey="Ticket"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :confirmData="pricingSkipAndAcceptData"
      @onConfirm="(response) => $emit('onPricingSkipAndAccept', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import Tickets from '@/services/tickets'

  import ConfirmModal from '@/components/_Part/_Modal/Confirm'

  export default {
    name: 'PricingSkipAndAccept',
    props: [
      'id'
    ],
    emits: [
      'onPricingSkipAndAccept'
    ],
    components: {
      ConfirmModal
    },
    methods: {
      fetchData() {
        return Tickets
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Preskočiť a prijať cenovú ponuku č.' + Item.id
      },
      setQuestion(Item) {
        return 'Naozaj chcete preskočiť a prijať cenovú ponuku č.' + Item.id + '?'
      },
      pricingSkipAndAcceptData() {
        return Tickets
          .pricingSkipAndAccept({
            id: this.id
          })
      }
    }
  }
</script>
